import React from 'react';
import { normalizeDescriptionBlocks, hasRenderableRichContent } from '../utils/productDescriptionRich';
import './ProductDescriptionRich.css';

/**
 * Renders structured description blocks on the product page.
 * Falls back to nothing if blocks are empty (parent should show plain description).
 */
const ProductDescriptionRich = ({ blocks, className = '' }) => {
  const list = normalizeDescriptionBlocks(blocks || []);
  if (!hasRenderableRichContent(list)) return null;

  return (
    <div className={`product-description-rich ${className}`.trim()}>
      {list.map((block) => {
        if (!block) return null;
        const color = block.textColor || '#333333';

        if (block.type === 'heading') {
          const t = (block.text || '').trim();
          if (!t) return null;
          const fw = block.bold ? 800 : 600;
          return (
            <h4
              key={block.id}
              className={`pdr-heading ${block.highlight ? 'pdr-heading--highlight' : ''}`}
              style={{ color, fontWeight: fw }}
            >
              {t}
            </h4>
          );
        }

        if (block.type === 'paragraph') {
          const t = (block.text || '').trim();
          if (!t) return null;
          return (
            <p
              key={block.id}
              className={`pdr-paragraph ${block.bold ? 'pdr-paragraph--bold' : ''}`}
              style={{ color, fontWeight: block.bold ? 700 : 400 }}
            >
              {t}
            </p>
          );
        }

        if (block.type === 'bullets') {
          const items = (block.items || []).map((x) => (typeof x === 'string' ? x : String(x ?? ''))).filter((x) => x.trim());
          if (items.length === 0) return null;
          return (
            <ul
              key={block.id}
              className={`pdr-bullets ${block.bold ? 'pdr-bullets--bold' : ''}`}
              style={{ color, fontWeight: block.bold ? 700 : 400 }}
            >
              {items.map((line, i) => (
                <li key={`${block.id}-${i}`}>{line.trim()}</li>
              ))}
            </ul>
          );
        }

        return null;
      })}
    </div>
  );
};

export default ProductDescriptionRich;
